import { DialogActions, DialogContent, DialogTitle, styled } from '@mui/material';

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  fontFamily: "'Open Sans', sans-serif",
  color: theme.palette.color50555b.main,
  fontSize: '18px',
  padding: '12px 16px',
  borderBottom: `1px solid #e5e5e5`
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  fontFamily: "'Open Sans', sans-serif",
  color: theme.palette.color50555b.main,
  padding: '12px !important'
}))

export const StyledLargeDialogContent = styled(DialogContent)(({ theme }) => ({
  color: theme.palette.color50555b.main,
  padding: '16px !important',
  fontFamily: "'Open Sans', sans-serif"
}))

export const StyledDialogFooter = styled(DialogActions)(({ theme }) => ({
  fontFamily: "'Open Sans', sans-serif",
  borderTop: `1px solid #e5e5e5`,
  color: theme.palette.color50555b.main,
  padding: '12px !important'
}))